/** ECL / linkout campaign id on shop and login URLs. */
export const LANDING_CAMPAIGN_QUERY_PARAM = 'campaign';

const CAMPAIGN_SOURCE = 'campaign';

const IN_APP_CAMPAIGN_CHECKOUT_PATH_PREFIX = '/login/campaign/';

const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

const isInAppCampaignCheckoutDeepLink = (url: URL): boolean =>
  url.pathname.startsWith(IN_APP_CAMPAIGN_CHECKOUT_PATH_PREFIX);

const UTM_PARAM_SET = new Set<string>(UTM_PARAMS);

export const isAttributionQueryParam = (
  key: string,
  value: string,
  params: URLSearchParams
): boolean => {
  if (key === LANDING_CAMPAIGN_QUERY_PARAM) {
    return true;
  }
  if (UTM_PARAM_SET.has(key)) {
    return true;
  }
  if (key === 'from' && value === CAMPAIGN_SOURCE) {
    return true;
  }
  if (key === 'token' && params.get('from') === CAMPAIGN_SOURCE) {
    return true;
  }
  return false;
};

export const copyAttributionSearchParams = (
  source: URLSearchParams,
  target: URLSearchParams
): void => {
  source.forEach((value, key) => {
    if (isAttributionQueryParam(key, value, source)) {
      target.set(key, value);
    }
  });
};

/**
 * Search string for the unauthenticated /shop → /login redirect: keeps the
 * params the login page already relies on and adds any attribution params so
 * the landing URL can still be captured on /login.
 */
export const buildLoginRedirectSearch = (search: string, preservedSearch: string): string => {
  if (search.includes(LANDING_CAMPAIGN_QUERY_PARAM)) {
    return search;
  }
  const preserved = new URLSearchParams(preservedSearch);
  copyAttributionSearchParams(new URLSearchParams(search), preserved);
  const q = preserved.toString();
  return q ? `?${q}` : '';
};

export const urlHasLandingAttribution = (url: URL): boolean => {
  let hasAttributionParam = false;
  url.searchParams.forEach((value, key) => {
    if (isAttributionQueryParam(key, value, url.searchParams)) {
      hasAttributionParam = true;
    }
  });
  if (hasAttributionParam) {
    return true;
  }
  if (isInAppCampaignCheckoutDeepLink(url)) {
    return false;
  }
  return url.pathname.includes('/campaign/');
};

/** External ECL linkout entry (not in-app campaign checkout / copied UTMs). */
export const urlIsEclLinkoutLanding = (url: URL): boolean => {
  if (isInAppCampaignCheckoutDeepLink(url)) {
    return false;
  }
  return url.searchParams.has(LANDING_CAMPAIGN_QUERY_PARAM);
};
